import { styled } from 'styled-components';

import { RichTextHeadline } from 'components/Text/RichTextHeadline';

export const CmsThreeStepCtaBlockHeadlineRichText = styled(RichTextHeadline)`
  p {
    line-height: 1.25;
    font-weight: inherit !important;
    margin: 0;
  }
`;
